let patient = [
  {
    path: '/patient',
    name: '加班门诊',
    component: () => import('@/pages/patient')
  }
]

export default patient
